// Measured in real Chrome across two origins (7-case frame matrix), because none of this is guessable:
//
// - Access depends on the *target document's* origin, not on the frames in between: our frame nested
//   under a cross-origin frame still reaches a same-origin `window.top`.
// - `sandbox="allow-scripts"` on our own origin yields an opaque origin — this returns false,
//   `localStorage` throws `SecurityError`, and a receiver sees `event.origin === "null"`. That is the
//   SafeFrame configuration.
// - **`location.origin` lies.** It reports the real origin for an opaque document, and `"null"` for a
//   `srcdoc` document that actually inherited its parent's origin. Only `event.origin` observed at the
//   receiver is trustworthy.
// - `postMessage` works in every one of those cases, at depth 3+, through cross-origin intermediates.
//
// So a false here is a legitimate, expected state, not a failure: the realm falls back to its own
// window, its own ctx and its own `page_impression_id`. That multi-queue outcome is accepted by
// design — see `createEphemeralCollector.ts` and the per-context counters in `sessionSeq.ts`.
const isTopWindowAccessible = () => {
    try {
        // Accessing any property of a cross-origin top window throws a SecurityError.
        return Boolean(window.top?.location.href);
    }
    catch {
        return false;
    }
};
export { isTopWindowAccessible };
